import { City } from './city';
import { Company } from './company';
import { Country } from './country';
import { Email } from './email';
import { MarketplaceUsernames } from './marketplace-usernames';
import { Marketplaces } from './marketplaces';
import { Name } from './name';
import { Phone } from './phone';
import { State } from './state';
import { Tags } from './tags';

export const customersGridColumns = [Name, Email, Phone, City, State, Country, Company, Marketplaces, MarketplaceUsernames, Tags];
